import { BillTo } from '@app/services/bavel-payment-manager-client.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-payment-detail-bill-to',
  templateUrl: './payment-detail-bill-to.component.html',
  styleUrls: ['./payment-detail-bill-to.component.scss'],
  standalone: false
})
export class PaymentDetailBillToComponent {
  @Input() public billTo: BillTo = {} as BillTo;
  @Output() public billToChange: EventEmitter<BillTo> = new EventEmitter();
}
